module.exports = __webpack_public_path__ + "img/hero-media.d1c8a08d.png";